<template>
  <div style="display: flex; flex-direction: column; height: 100%; width: 100%">
    <div class="flex-grow-1">
      <v-text-field
        :model-value="modelValue.name"
        @update:model-value="update('name', $event)"
        autofocus
        filled
        label="Channel Name"
        @keyup.enter="handleCreate"></v-text-field>
      <v-textarea
        :model-value="modelValue.description"
        @update:model-value="update('description', $event)"
        filled
        rows="10"
        no-resize
        label="Channel Description"></v-textarea>
    </div>

    <div class="d-flex pt-3 align-center">
      <v-spacer />
      <v-btn
        color="primary"
        variant="flat"
        :loading="loading"
        :disabled="!modelValue.name"
        @click="handleCreate">
        <v-icon class="mr-2">mdi-content-save</v-icon>
        Create & Assign
      </v-btn>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'create']);

function update(key, value) {
  emit('update:modelValue', { ...props.modelValue, [key]: value });
}

function handleCreate() {
  // Guard against creating when disabled
  if (!props.modelValue.name) return;
  emit('create');
}
</script>
